<template>
  <div class="h-100">
    <header-component />
    <main id="main">
      <menu-component />
      <section id="content">
        <transition mode="out-in" name="fadeShort">
          <router-view />
        </transition>
      </section>
    </main>
    <footer-component />
  </div>
</template>
<script>
import HeaderComponent from '@/components/header/Header'
import MenuComponent from '@/components/Menu'
import FooterComponent from '@/components/Footer'

export default {
  components: {
    HeaderComponent,
    MenuComponent,
    FooterComponent,
  },
}
</script>
